<mat-form-field [formGroup]="form">
  <mat-label>{{ label }}</mat-label>
  <input type="time" matInput 
         [value]="value || null"
         [attr.placeholder]="placeholder || null"
         [formControlName]="formControlName">
  <mat-icon matSuffix (click)="onClickTimpePicker()">alarm</mat-icon>
  <mat-error *ngIf="control?.['errors']?.['required']">
    El Campo es requerido
  </mat-error>
  <mat-error *ngIf="control?.['errors']?.['moretimeOfstarttime']">
    No puede ser menor que la hora inicial.
  </mat-error>  
  <mat-error *ngIf="control?.['errors']?.['lestimeOfendtime']">
    No puede ser mayor que la hora final.
  </mat-error>
</mat-form-field>